import React from 'react';
import { WithClassname } from '../../types';
import { StoreDetails } from '../../types/store';
import { GoogleMap, Marker } from '@react-google-maps/api';
import classnames from 'classnames';

type Props = WithClassname & {
  data: StoreDetails;
};

export default function StoreLocation({ data, className }: Props) {
  const mapsUrl = `https://www.google.com/maps/embed/v1/place?q=place_id:${data.google_place.id}&key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}&center=${data.location.lat},${data.location.lng}&zoom=16`;

  if (!data.id) {
    return null;
  }

  return data.google_place.id ? (
    <div className="size-full">
      <iframe
        src={mapsUrl}
        className={classnames('h-full w-full', className)}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  ) : (
    <GoogleMap
      mapContainerClassName={classnames('h-full w-full', className)}
      center={{
        lat: data.location.lat,
        lng: data.location.lng,
      }}
      zoom={12}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT,
        },
      }}
    >
      <Marker
        label={data.name}
        position={{
          lat: data.location.lat,
          lng: data.location.lng,
        }}
      />
    </GoogleMap>
  );
}
